import React from 'react';
import { StyledBtnComponent } from '../../../dto/StyleCompRepository';

interface HeadlessBtnProps {
  value: string;
  handleClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  StyledBtn: StyledBtnComponent;
  disabled?: boolean;
};

const HeadlessBtn: React.FC<HeadlessBtnProps> = ({
  value,
  handleClick,
  StyledBtn,
  disabled,
}) => {
  return (
    <StyledBtn onClick={handleClick} disabled={disabled}>
      {value}
    </StyledBtn>
  );
}

export default HeadlessBtn;